import React, { useContext, useEffect } from 'react'
import { ThemeContext } from '@/container/ThemeProvider'

function withTheme(Component, theme = 'white') {
	function Wrapper(props) {
		const { setTheme } = useContext(ThemeContext)

		useEffect(() => {
			setTheme(theme)
		})

		return <Component {...props} />
	}

	return Wrapper
}

export default withTheme
